export default Object.freeze({
    FULFILLED: 'fulfilled',
    REJECTED: 'rejected'
  })
  